import React, { useEffect, useRef } from "react";
import { Typography, Stack, Container, Grid } from "@mui/material";

const UserDescription = ({ currentValue, desc, userSkills }) => {
  useEffect(() => {
    if (currentValue == "about") {
      about.current?.scrollIntoView({ behavior: "smooth" });
    }
    if (currentValue == "skills") {
      about.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentValue]);

  const about = useRef();
  const skills = useRef();

  return (
    <div>
      <Container>
        <Stack className="mb-16">
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            className="mb-10"
            ref={about}
          >
            About
          </Typography>
          <Typography variant="body2" gutterBottom>
            {desc}
          </Typography>
        </Stack>
        <Stack className="mb-16">
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            className="mb-10"
            ref={skills}
          >
            Skills
          </Typography>

          <Grid container spacing={3}>
            {userSkills.map((item) => (
              <Grid item xs="auto">
                <Typography className="ammanat-darker-gray skill-pill">
                  {item.label}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Container>
    </div>
  );
};

export default UserDescription;
